// extracted by mini-css-extract-plugin
module.exports = {"center":"style_center__2e5lH","hleperText":"style_hleperText__1I-Wk"};